/**
 * Teams — AI Agent Teams marketplace
 * Users can hire pre-built teams of AI experts for different niches
 * Each team uses ELON ROUTER LLM 3.3 with pre-installed cerebros
 */

import { useState } from 'preact/hooks';
import { route } from 'preact-router';
import { isLoggedIn } from '../stores/auth.store';
import { LoginPage } from './Login';
import { T } from '../styles/tokens';
import { Button } from '../components/ui';

interface TeamMember {
  name: string;
  role: string;
  avatar: string;
  description: string;
}

interface Team {
  id: string;
  name: string;
  slug: string;
  icon: string;
  color: string;
  colorLight: string;
  gradient: string;
  description: string;
  longDescription: string;
  priceMonth: number;
  priceCurrency: string;
  members: TeamMember[];
  features: string[];
  popular?: boolean;
}

const TEAMS: Team[] = [
  {
    id: 'tech',
    name: 'Tech & Desenvolvimento',
    slug: 'tech',
 icon: '',
    color: T.primary,
    colorLight: T.primaryBg,
    gradient: 'linear-gradient(135deg, #2F6BFF, #8B5CF6)',
    description: 'CTO virtual com os maiores nomes da tecnologia.',
    longDescription: 'Time completo de agentes IA com a mente dos maiores líderes tech do mundo. Arquitetura, código, infraestrutura, automação — tudo coberto.',
    priceMonth: 497,
    priceCurrency: 'BRL',
    members: [
 { name: 'Elon Musk', role: 'Visão & Inovação', avatar: '', description: 'Pensamento 10x, automação agressiva, first principles' },
 { name: 'Mark Zuckerberg', role: 'Produto & Escala', avatar: '', description: 'Growth hacking, social features, escala massiva' },
 { name: 'Jeff Bezos', role: 'Infraestrutura & Ops', avatar: '', description: 'Sistemas distribuídos, AWS mindset, obsessão por cliente' },
 { name: 'Linus Torvalds', role: 'Código & Arquitetura', avatar: '', description: 'Clean code, performance, sistemas operacionais' },
    ],
    features: [
      'Arquitetura de sistemas completos',
      'Code review automático por 4 experts',
      'CI/CD e DevOps otimizado',
      'Decisões técnicas com visão de produto',
      'ELON ROUTER LLM 3.3 incluído',
    ],
    popular: true,
  },
  {
    id: 'seo',
    name: 'SEO & Tráfego Orgânico',
    slug: 'seo',
 icon: '',
    color: T.success,
    colorLight: T.successBg,
    gradient: 'linear-gradient(135deg, #10B981, #34D399)',
    description: 'Domine o Google com os maiores experts de SEO.',
    longDescription: 'Time de agentes IA treinados com o conhecimento dos maiores especialistas em SEO do mundo. Keyword research, link building, conteúdo otimizado.',
    priceMonth: 397,
    priceCurrency: 'BRL',
    members: [
 { name: 'Neil Patel', role: 'Estratégia SEO', avatar: '', description: 'Content marketing, keyword strategy, analytics' },
 { name: 'Brian Dean', role: 'Link Building', avatar: '', description: 'Skyscraper technique, backlinks, autoridade' },
 { name: 'Rand Fishkin', role: 'Technical SEO', avatar: '', description: 'On-page, estrutura, featured snippets' },
 { name: 'Ahrefs Bot', role: 'Análise de Dados', avatar: '', description: 'Competidores, gaps, oportunidades de ranking' },
    ],
    features: [
      'Auditoria técnica completa do site',
      'Keyword research com análise de competidores',
      'Conteúdo otimizado para Google',
      'Link building strategy automatizada',
      'ELON ROUTER LLM 3.3 incluído',
    ],
  },
  {
    id: 'marketing',
    name: 'Marketing & Growth',
    slug: 'marketing',
 icon: '',
    color: T.warning,
    colorLight: T.warningBg,
    gradient: 'linear-gradient(135deg, #F59E0B, #F97316)',
    description: 'Growth hacking com os melhores do marketing digital.',
    longDescription: 'Time de agentes IA com a mente dos maiores marqueteiros do mundo. Copywriting, funis, ads, branding — tudo automatizado.',
    priceMonth: 397,
    priceCurrency: 'BRL',
    members: [
 { name: 'Gary Vaynerchuk', role: 'Social & Branding', avatar: '', description: 'Conteúdo viral, personal branding, redes sociais' },
 { name: 'Russell Brunson', role: 'Funis & Conversão', avatar: '', description: 'Funnels, landing pages, copywriting persuasivo' },
 { name: 'Seth Godin', role: 'Estratégia & Posicionamento', avatar: '', description: 'Marketing de permissão, tribe building, diferenciação' },
 { name: 'Alex Hormozi', role: 'Ofertas & Vendas', avatar: '', description: 'Ofertas irresistíveis, pricing, escala de vendas' },
    ],
    features: [
      'Copywriting de alta conversão',
      'Funis de vendas automatizados',
      'Estratégia de conteúdo multi-plataforma',
      'Análise de métricas e otimização',
      'ELON ROUTER LLM 3.3 incluído',
    ],
  },
  {
    id: 'design',
    name: 'Design & UX',
    slug: 'design',
 icon: '',
    color: T.danger,
    colorLight: T.dangerBg,
    gradient: 'linear-gradient(135deg, #EC4899, #8B5CF6)',
    description: 'Design de produto com visão dos melhores do mundo.',
    longDescription: 'Time de agentes IA inspirados nos maiores designers e pensadores de UX. Interfaces bonitas, intuitivas e que convertem.',
    priceMonth: 347,
    priceCurrency: 'BRL',
    members: [
 { name: 'Jony Ive', role: 'Design de Produto', avatar: '', description: 'Minimalismo, materiais, design emocional' },
 { name: 'Don Norman', role: 'UX & Usabilidade', avatar: '', description: 'Design centrado no usuário, acessibilidade' },
 { name: 'Julie Zhuo', role: 'Design Systems', avatar: '', description: 'Design systems, consistência, escala' },
 { name: 'Dieter Rams', role: 'Princípios de Design', avatar: '', description: '10 princípios, menos é mais, funcionalidade' },
    ],
    features: [
      'UI/UX de alta conversão',
      'Design system consistente',
      'Protótipos e wireframes',
      'Testes de usabilidade automatizados',
      'ELON ROUTER LLM 3.3 incluído',
    ],
  },
];

function formatPrice(price: number): string {
  return `R$ ${price}`;
}

export function TeamsPage() {
  if (!isLoggedIn.value) return <LoginPage />;

  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);

  if (selectedTeam) {
    return <TeamDetail team={selectedTeam} onBack={() => setSelectedTeam(null)} />;
  }

  return (
    <div style={{ padding: '24px', maxWidth: 960, margin: '0 auto', position: 'relative' }}>
      {/* Aurora glow */}
      <div style={{
        position: 'absolute', top: -120, left: '50%', transform: 'translateX(-50%)',
        width: 600, height: 300, pointerEvents: 'none', zIndex: 0,
        background: `radial-gradient(ellipse, ${T.warningBgSubtle} 0%, rgba(236,72,153,0.03) 40%, transparent 70%)`,
      }} />

      {/* Back */}
      <Button variant="ghost"
        onClick={() => route('/agents')}
        style={{
          background: 'none', border: 'none', color: T.textMuted, cursor: 'pointer',
          fontSize: 13, fontWeight: 600, padding: '4px 0', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 6,
        }}
      >
        ← Meus Agentes
      </Button>

      <div style={{ textAlign: 'center', marginBottom: 48, position: 'relative', zIndex: 1 }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: T.text, margin: '0 0 12px', letterSpacing: '-0.5px' }}>
 Times de Agentes IA
        </h1>
        <p style={{ color: T.textMuted, fontSize: 16, margin: '0 0 8px', maxWidth: 520, marginLeft: 'auto', marginRight: 'auto' }}>
          Alugue um time completo de especialistas IA. Cada agente tem o cérebro de um expert real.
        </p>
        <p style={{ color: T.textMuted, fontSize: 13, margin: 0 }}>
          Powered by <strong style={{ color: T.text }}>ELON ROUTER LLM 3.3</strong> • Setup pronto em minutos
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 24,
        position: 'relative',
        zIndex: 1,
      }}>
        {TEAMS.map((team) => (
          <div
            key={team.id}
            onClick={() => setSelectedTeam(team)}
            class="team-card"
            style={{
              padding: '28px 24px', background: T.bgCard, borderRadius: 20,
              border: `1px solid ${team.color}33`, cursor: 'pointer',
              transition: 'all 0.25s ease', position: 'relative', overflow: 'hidden',
            }}
          >
            {/* Top accent */}
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, height: 3,
              background: team.gradient, borderRadius: '20px 20px 0 0',
            }} />

            {/* Popular badge */}
            {team.popular && (
              <div style={{
                position: 'absolute', top: 16, right: 16,
                background: team.gradient, color: T.text,
                fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 20,
                letterSpacing: '0.5px', textTransform: 'uppercase' as const,
              }}>
 Popular
              </div>
            )}

            {/* Icon */}
            <div style={{
              width: 64, height: 64, borderRadius: 18, marginBottom: 20,
              background: team.colorLight, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 32, border: `1px solid ${team.color}25`,
            }}>
              {team.icon}
            </div>

            <h3 style={{ fontSize: 19, fontWeight: 800, color: T.text, margin: '0 0 8px' }}>{team.name}</h3>
            <p style={{ color: T.textMuted, fontSize: 13, margin: '0 0 20px', lineHeight: '1.5' }}>
              {team.description}
            </p>

            {/* Members preview */}
            <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
              {team.members.map((m, i) => (
                <div key={i} title={m.name} style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: team.colorLight, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, border: `1px solid ${team.color}15`,
                }}>
                  {m.avatar}
                </div>
              ))}
            </div>

            {/* Price */}
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 16 }}>
              <span style={{ fontSize: 28, fontWeight: 800, color: T.text }}>{formatPrice(team.priceMonth)}</span>
              <span style={{ fontSize: 13, color: T.textMuted, fontWeight: 500 }}>/mês</span>
            </div>

            <span style={{
              display: 'block', textAlign: 'center', padding: '12px 24px', borderRadius: 12,
              background: team.gradient, color: T.text, fontSize: 14, fontWeight: 700,
            }}>
              Contratar time →
            </span>
          </div>
        ))}
      </div>

      <style>{`
        .team-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 48px var(--t-black-alpha-15), 0 0 0 1px var(--t-white-alpha-5);
        }
      `}</style>
    </div>
  );
}

function TeamDetail({ team, onBack }: { team: Team; onBack: () => void }) {
  return (
    <div style={{ padding: '24px', maxWidth: 720, margin: '0 auto' }}>
      <Button variant="ghost"
        onClick={onBack}
        style={{
          background: 'none', border: 'none', color: T.textMuted, cursor: 'pointer',
          fontSize: 13, fontWeight: 600, padding: '4px 0', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 6,
        }}
      >
        ← Voltar para times
      </Button>

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <div style={{
          width: 80, height: 80, borderRadius: 22, margin: '0 auto 20px',
          background: team.colorLight, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 40, border: `1px solid ${team.color}25`,
        }}>
          {team.icon}
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: T.text, margin: '0 0 12px' }}>{team.name}</h1>
        <p style={{ color: T.textMuted, fontSize: 15, margin: 0, maxWidth: 500, marginLeft: 'auto', marginRight: 'auto', lineHeight: '1.6' }}>
          {team.longDescription}
        </p>
      </div>

      {/* Members */}
 <h2 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: '0 0 20px' }}>Membros do Time</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginBottom: 40 }}>
        {team.members.map((m, i) => (
          <div key={i} style={{
            padding: '20px', background: T.bgCard, borderRadius: 16,
            border: `1px solid ${team.color}20`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 14,
                background: team.colorLight, display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 24, border: `1px solid ${team.color}15`,
              }}>
                {m.avatar}
              </div>
              <div>
                <h4 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: 0 }}>{m.name}</h4>
                <span style={{ fontSize: 12, color: team.color, fontWeight: 600 }}>{m.role}</span>
              </div>
            </div>
            <p style={{ color: T.textMuted, fontSize: 12, margin: 0, lineHeight: '1.5' }}>{m.description}</p>
          </div>
        ))}
      </div>

      {/* Features */}
 <h2 style={{ fontSize: 20, fontWeight: 800, color: T.text, margin: '0 0 20px' }}>O que está incluído</h2>
      <div style={{
        padding: '24px', background: T.bgCard, borderRadius: 16,
        border: `1px solid ${team.color}20`, marginBottom: 40,
      }}>
        {team.features.map((f, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '10px 0',
            borderBottom: i < team.features.length - 1 ? `1px solid var(--border-subtle, ${T.border})` : 'none',
          }}>
            <span style={{ color: team.color, fontSize: 16 }}></span>
            <span style={{ color: T.text, fontSize: 14, fontWeight: 500 }}>{f}</span>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{
        textAlign: 'center', padding: '32px', background: T.bgCard, borderRadius: 20,
        border: `1px solid ${team.color}30`,
      }}>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: 4, marginBottom: 8 }}>
          <span style={{ fontSize: 36, fontWeight: 800, color: T.text }}>{formatPrice(team.priceMonth)}</span>
          <span style={{ fontSize: 15, color: T.textMuted }}>/mês</span>
        </div>
        <p style={{ color: T.textMuted, fontSize: 12, margin: '0 0 24px' }}>
          Cancele a qualquer momento • Setup instantâneo
        </p>
        <Button variant="ghost"
          onClick={() => {
            // TODO: integrate with checkout
            alert('Em breve! Checkout de times está sendo implementado.');
          }}
          style={{
            background: team.gradient, color: T.text, border: 'none',
            padding: '16px 48px', borderRadius: 14, fontSize: 16, fontWeight: 700,
            cursor: 'pointer', transition: 'transform 0.2s',
          }}
        >
 Contratar {team.name}
        </Button>
      </div>
    </div>
  );
}
